import { useState } from "react";
import { toast } from "sonner";
import { RefreshCw } from "lucide-react";

/**
 * Force-refresh button: unregisters all service workers, clears all caches,
 * and reloads the page. Gives PWA users an in-app way to force an update
 * when pull-to-refresh is unavailable (installed PWA, standalone mode).
 */
export function UpdateAppButton() {
  const [updating, setUpdating] = useState(false);

  const handleUpdate = async () => {
    if (updating) return;
    setUpdating(true);
    const tid = toast.loading("Aggiornamento app in corso...");
    try {
      if ("serviceWorker" in navigator) {
        const regs = await navigator.serviceWorker.getRegistrations();
        await Promise.all(regs.map((r) => r.unregister()));
      }
      if ("caches" in window) {
        const keys = await caches.keys();
        await Promise.all(keys.map((k) => caches.delete(k)));
      }
      toast.success("App aggiornata, ricarico...", { id: tid, duration: 1000 });
      setTimeout(() => {
        window.location.reload();
      }, 400);
    } catch (err) {
      toast.error("Errore aggiornamento: " + (err?.message || "sconosciuto"), { id: tid });
      setUpdating(false);
    }
  };

  return (
    <button
      type="button"
      onClick={handleUpdate}
      disabled={updating}
      data-testid="update-app-btn"
      title="Aggiorna l'app all'ultima versione (pulisce cache e ricarica)"
      className="w-11 h-11 rounded-xl bg-white/5 border border-white/10 hover:border-cyan-500/40 hover:bg-cyan-500/10 flex items-center justify-center transition-colors active:scale-95 disabled:opacity-50 shrink-0"
    >
      <RefreshCw className={`w-5 h-5 text-zinc-300 ${updating ? "animate-spin" : ""}`} />
    </button>
  );
}
